import React from 'react';
import { Props } from '@components/divider/src/divider.types';
import { cn } from '@utils/cn';

export const Divider = ({ className, ...props }: Props) => (
  <div
    className={cn(
      'mx-auto my-6 flex w-full items-center justify-between gap-3 text-sm text-neutral-50 dark:text-neutral-0',
      className
    )}
    {...props}>
    <div className='h-[1px] w-full bg-neutral-8 dark:bg-neutral-50' />
  </div>
);
